import { getRequestsListApi, raiseNotificationApi, setStatusOfUserRelApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import Staffs from './Staffs';

import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { IoIosExpand } from "react-icons/io";

import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';

function StaffOnAttorney() {
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const [requests, setRequests] = useState([]);
    const [approved, setApproved] = useState([]);
    const [singleUser, setSingleUser] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const profData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  
    }
    const [sentReq, setSentReq] = useState(false);

    useEffect(() => {
        makeApiCallFunc(getRequestsListApi,
            null,
            ({data}) => {setRequests(data.requests?.filter(request => request?.assistantId !== null));
                 setApproved(data.approved?.filter(approved => approved?.assistantId !== null))},
            (data) => console.log(data) 
        )
    },[sentReq])
    const approve = (id) => {
        makeApiCallFunc(setStatusOfUserRelApi,
            {
                userId: userDetails?._id,
                assistantId: id,
                status: 1
            },
            (data) => {
                setSentReq(prev => !prev);
                const notificationObj = {
                    title : "Request approved " + userDetails?.firstName + " " + userDetails?.lastName,
                    is_read : false,
                    sender: userDetails._id,
                    type: "1",
                    receiver:  id,
                    content: "Your request to represent "+userDetails?.firstName+" "+userDetails?.lastName+" has been approved. You shall starting seeing their case profile now.",
                    }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                        (data) => console.log(data),
                        (error) => console.log(error)
                    )
            },
            (data) => console.log(data),

        )
    }
    const deny = (id) => {
        makeApiCallFunc(setStatusOfUserRelApi,
            {
                userId: userDetails?._id,
                assistantId: id,
                status: 2
            },
            (data) => {setSentReq(prev => !prev);
                const notificationObj = {
                    title : "Request denied",
                    is_read : false,
                    sender: userDetails._id,
                    type: "2",
                    receiver:  id,
                    content: "Your request to represent "+userDetails?.firstName+" "+userDetails?.lastName+" has been denied. Reach out and try again with valid profile details.",
                    }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                        (data) => console.log(data),
                        (error) => console.log(error)
                    )

            },
            (data) => console.log(data),

        )
    }
    const revoke = (id) => {
        makeApiCallFunc(setStatusOfUserRelApi,
            {
                userId: userDetails?._id,
                assistantId: id,
                status: 3
            },
            (data) => {setSentReq(prev => !prev);
                const notificationObj = {
                    title : "Access revoked",
                    is_read : false,
                    sender: userDetails._id,
                    type: "2",
                    receiver:  id,
                    content: "Your access to represent attorney "+userDetails?.firstName+" "+userDetails?.lastName+" has been revoked by the attorney. ",
                    }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                        (data) => console.log(data),
                        (error) => console.log(error)
                    )

            },
            (data) => console.log(data),

        )
    }
  return (
    <>
    {
        showModal &&
        <>
        <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}/>
        </>
    }
    <div className='w-full px-2 lg:px-40 mt-4 lg:mt-20'>
        <div className='w-full flex justify-center flex-col mt-10 border p-4'>
            <div className='text-sm font-bold underline text-sky-600 mb-4'>Add a new team member</div>
            <Staffs setSentReq={setSentReq}/>
        </div>
        <div className='w-full'>
        {requests.length > 0 && 
        <>
            <div className='text-sm font-bold underline text-sky-600 mb-4 mt-10'> Requests Sent by Assistants:</div>
                {
                    requests?.map((item, key) => {
                        
                        return ( <>
                            {item?.assistantId?.profilePic ?
                        <div className='w-full flex  justify-between px-2 lg:px-6 py-4 items-center  border grid grid-cols-11'>
                            <div className=' col-span-2 lg:col-span-1'> <img className="w-12 h-12 " src = {item?.assistantId?.profilePic}/> </div>
                            <div className=' col-span-1 hidden lg:flex'> {item?.assistantId?.firstName}  {item?.assistantId?.lastName}  </div>
                            <div className=' col-span-5 hidden lg:flex text-center'> {item?.assistantId?.email} </div>
                          
                           <div className='flex col-span-9 lg:col-span-4  '>
                                <div className='bg-green-700 shadow-md flex cursor-pointer text-white hover:bg-green-800 lg:p-2 py-2 pl-1 lg:px-2 text-xs w-max font-bold' onClick={(e) => approve(item?.assistantId?._id)}>
                                <IoCheckmarkCircleOutline className='w-4 h-4 mr-1'/>
                                    Add Assistant</div>
                                <div className='bg-red-700  shadow-md flex cursor-pointer text-white hover:bg-red-800 lg:p-2 py-2 px-1 lg:px-2 text-xs w-max font-bold' onClick={(e) => deny(item?.assistantId?._id)}>
                                <RxCrossCircled className='w-4 h-4 mr-1'/>
                                    Deny</div>
                                <div
                                 className='bg-sky-700 shadow-md flex cursor-pointer text-white hover:bg-sky-800 lg:p-2 py-2 pr-1 lg:px-2 text-xs w-max font-bold' 
                                    onClick={() => {setSingleUser(item?.assistantId); setShowModal(true)}}
                                >
                                     <IoIosExpand className='w-4 h-4 mr-1'/>
                                   See Details</div>
                           </div>
                           
                            
                        </div>
                    :
                    <></>}</>)
                    })
                }  
            </> 
        } 
        {approved.length > 0 &&
        <>
        <div className='text-sm font-bold underline text-sky-600 mb-4 mt-10'>Assistants acting on your behalf </div>
            {
                approved?.map((item, key) => {
                    return ( 
                    <div className='w-full flex  justify-between px-4 py-1 items-center  border'>
                        <div className='w-12 h-12 hidden lg:flex'> <img src = {item?.assistantId?.profilePic}/> </div>
                        <div className='w-10 h-10 hidden lg:flex items-center'> {item?.assistantId?.firstName} </div>
                        <div className='w-10 h-10 hidden lg:flex items-center'> {item?.assistantId?.lastName} </div>
                        <div className='w-max flex items-center'> {item?.assistantId?.email} </div>

                        <div className='text-green-600 underline rounded p-2 px-2 text-xs w-10 font-bold'
                            onClick={() => {setSingleUser(item?.assistantId); setShowModal(true)}}
                        
                        >Details</div>
                        <div className='bg-red-800  text-white rounded p-2 px-2 text-xs w-max font-bold cursor-pointer' onClick={(e) => revoke(item?.assistantId?._id)}>Revoke Access</div>

                    </div>)
                })
            }
            </>
        }
        </div>
        
    </div>
    </>
  )
}

export default StaffOnAttorney